export default "__VITE_ASSET__CV3SA4Ua__"